import { createFileRoute } from '@tanstack/react-router'
import { Waitlist } from '@/features/waitlist/views/waitlist'
import { client } from '@/features/query/client'
import CoinAnimation from '@/ui/loader'
import {
  referralControllerGetBalance,
  getReferralControllerGetBalanceQueryKey,
  getReferralControllerListQueryKey,
  referralControllerList,
} from '@/api/referrals/referrals'

export const Route = createFileRoute('/waitlist')({
  component: RouteComponent,
  loader: async () => {
    return Promise.allSettled([
      client.prefetchQuery({
        queryKey: getReferralControllerListQueryKey(),
        queryFn: () => referralControllerList(),
      }),
      client.prefetchQuery({
        queryKey: getReferralControllerGetBalanceQueryKey(),
        queryFn: () => referralControllerGetBalance(),
      }),
    ])
  },
  pendingComponent: CoinAnimation,
})

function RouteComponent() {
  return <Waitlist />
}
